import { ReactNode } from "react"
import { localizeText } from "src/localization/utils"

const mainId = "main"

export type MinimalLayoutProps = {
  children: ReactNode
}

export function MinimalLayout({ children }: MinimalLayoutProps) {
  const T = localizeText(text)

  return (
    <>
      <a href={"#" + mainId} className="sr-only">
        {T.toContent}
      </a>

      <main id={mainId} className="relative w-full flex-1">
        {children}
      </main>
    </>
  )
}

const de = {
  toContent: "Zum Inhalt",
}

const en: typeof de = {
  toContent: "To content",
}

const text = { de, en }
